import React from 'react';
import { DCFTVTContextValues } from './types';

const DCFTVTContext = React.createContext<DCFTVTContextValues>({
  revenueMultipleOptions: [],
  ebitdaMultipleOptions: [],
});

export default DCFTVTContext;
